module.exports = __webpack_public_path__ + "static/img/shenfenzhengzhengmian@2x.dd7e2065.png";